import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
  REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
  REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
  REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
  REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
  REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
} from '/enum/records.enum';
import {currentScreen} from '/redux/selector/navigation.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {reportMeta} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {PeopleToContactContent} from './PeopleToContactContent';

export default connect((state, ownProps: any) => ({
  ...createStructuredSelector({
    currentScreen,
    noOrderMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    })(reportMeta),
    expiringRewardsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
    })(reportMeta),
    recentlyInactiveMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    })(reportMeta),
    premierCancellationsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    })(reportMeta),
    expiringWellnessCreditsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    })(reportMeta),
    nextTaskMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    })(reportMeta),
    noActiveOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
    })(reportMeta),
    noRXOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(reportMeta),
    newCandidateMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    })(reportMeta),
    noRXOrderMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(reportMeta),
    featureFlag: variablesFeatureFlag,
  })(state),
  ...ownProps,
}))(PeopleToContactContent);
